import { iconBoxClass } from "../utils/iconBoxClasses";

/**
 * Tinted icon container — same rounded-xl shape site-wide.
 * @param {"xs"|"sm"|"md"|"lg"|"xl"|"2xl"} size
 */
export default function IconBox({
  size = "xl",
  tone = "",
  className = "",
  children,
}) {
  return (
    <div className={iconBoxClass(size, tone, className)}>{children}</div>
  );
}
